import { useLayoutEffect, useRef, useState, type ReactNode } from "react"

const DESIGN_W = 1200

/** Renders children at the Figma 1200px artboard, scaled to the parent width. */
export function DesignCanvas({ children }: { children: ReactNode }) {
  const outerRef = useRef<HTMLDivElement>(null)
  const innerRef = useRef<HTMLDivElement>(null)
  const [scale, setScale] = useState(1)
  const [height, setHeight] = useState(0)

  useLayoutEffect(() => {
    const outer = outerRef.current
    const inner = innerRef.current
    if (!outer || !inner) return

    const update = () => {
      const next = outer.clientWidth / DESIGN_W
      setScale(next)
      setHeight(inner.scrollHeight * next)
    }
    update()
    const ro = new ResizeObserver(update)
    ro.observe(outer)
    ro.observe(inner)
    const images = [...inner.querySelectorAll("img")]
    images.forEach((img) => img.addEventListener("load", update))
    return () => {
      ro.disconnect()
      images.forEach((img) => img.removeEventListener("load", update))
    }
  }, [])

  return (
    <div ref={outerRef} className="relative w-full overflow-hidden bg-dark-base" style={{ height }}>
      <div
        ref={innerRef}
        data-slot="aura-scan-report"
        className="absolute left-0 top-0 w-[1200px] origin-top-left bg-dark-base"
        style={{ transform: `scale(${scale})` }}
      >
        {children}
      </div>
    </div>
  )
}
